import React, { useEffect, useRef, useCallback, useState } from 'react';
import { useHistory } from 'react-router-dom';

import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import * as Yup from 'yup';

import { Container } from 'react-bootstrap';

import { useAuth } from '../../hooks/auth';

import SelectSync from '../../components/SelectSync';

import Modal from '../../components/Modal';
import Button from '../../components/Button';

import getValidationErrors from '../../utils/getValidationErrors';
import ListaClinicas, { RefObject } from './ListaClinicas';
import ClinicasCadastroPagina, { IClinica } from './ClinicasCadastro';

export interface IFormBusca {
  situacao?: string;
}

const ClinicaCadastro: React.FC = () => {
  const listaRef = useRef<RefObject>(null);
  const history = useHistory();
  const { user } = useAuth();
  const [dadosForm, setDadosForm] = useState<IFormBusca | undefined>(undefined);

  const formRefBusca = useRef<FormHandles>(null);

  const [showModalCadastro, setShowModalCadastro] = useState(false);

  useEffect(() => {
    if (user.UsuCodigo !== 1) {
      history.push('/sempermissao');
    }
  }, [history, user.UsuCodigo]);

  const initialData = {
    situacao: 'true',
    clinica: user.UsuClinica.toString(),
  };

  const handleSubmitBusca = useCallback(async (dados: IFormBusca) => {
    try {
      formRefBusca.current?.setErrors({});
      const schema = Yup.object().shape({
        situacao: Yup.string().nullable(true),
      });

      await schema.validate(dados, {
        abortEarly: false,
      });

      setDadosForm(dados);
    } catch (error) {
      if (error instanceof Yup.ValidationError) {
        const errors = getValidationErrors(error);
        formRefBusca.current?.setErrors(errors);
      }
    }
  }, []);

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  const handleOnChangeVazio = useCallback(() => {}, []);

  const handleAdd = useCallback(
    async (
      dadosConfiguracaoAgenda: IClinica,
      cliCodigo: number | undefined,
    ) => {
      if (listaRef.current) {
        await listaRef.current.addClinica(dadosConfiguracaoAgenda, cliCodigo);
        setShowModalCadastro(false);
      }
    },
    [],
  );

  return (
    <Container fluid className="mt-2">
      {showModalCadastro && (
        <Modal
          show={showModalCadastro}
          titulo="Cadastro de Clinicas"
          handleFecharModal={() => setShowModalCadastro(false)}
          large
        >
          <ClinicasCadastroPagina addClinica={handleAdd} />
        </Modal>
      )}
      <div className="bg-white border p-2 mb-2">
        <div className="d-flex justify-content-between mb-2">
          <h2 id="topoBusca">Clinicas</h2>
        </div>

        <Form
          ref={formRefBusca}
          initialData={initialData}
          onSubmit={handleSubmitBusca}
        >
          <div className="row no-gutters">
            <div className="col-md-2 mr-1">
              <SelectSync
                name="situacao"
                label="Situação"
                placeholder="Selecione"
                isClearable
                handleSelectChange={handleOnChangeVazio}
                options={[
                  { label: 'Todos', value: '' },
                  { label: 'Ativo', value: 'true' },
                  { label: 'Desativado', value: 'false' },
                ]}
              />
            </div>
            <div className="col-md-1">
              <div className="input-group-append mt-3">
                <Button type="submit" variant="secondary-outline">
                  BUSCAR
                </Button>
              </div>
            </div>
          </div>
        </Form>
      </div>

      <div className="bg-white border p-2">
        <ListaClinicas ref={listaRef} dados={dadosForm} />
      </div>
    </Container>
  );
};

export default ClinicaCadastro;
